<template>
    <!-- Importing Home Component -->
    <resetComp></resetComp>
  </template>
  <script>
  import resetComp from "../../components/Auths/ResetPassword.vue";
  
  export default {
    name: "Commission Report",
    components: { resetComp },
    computed: {},
    mounted() {},
  };
  </script>
  